import React from 'react';

const Heading = () => {
  return (
    <div className="sm:mx-auto sm:w-full sm:max-w-xl px-2">
      <h2 className="mt-6 text-2xl font-semibold leading-9 text-center text-gray-900 sm:text-3xl">
        Google Workspace Add-ons
      </h2>
      <p className="mt-4 text-sm text-center text-gray-500 md:text-base leading-6">
        Our add-ons have passed the security audit verified by Google and &nbsp;
        <span className="border-b-4 border-yellow-100">
          certified 100% compliant
        </span>
        &nbsp;with the Google API User Data Policy.
      </p>
    </div>
  );
};

export default Heading;
